module.exports = __webpack_public_path__ + "img/fudan.6d1340cc.png";